import { render, staticRenderFns } from "./SearchListView.vue?vue&type=template&id=1a0626f0&scoped=true&"
import script from "./SearchListView.vue?vue&type=script&lang=js&"
export * from "./SearchListView.vue?vue&type=script&lang=js&"
import style0 from "./SearchListView.vue?vue&type=style&index=0&id=1a0626f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0626f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
